/*
  Lisen – toplinjen toner mellem beskederne (Lone, 22. sep. 2026)
  Hører til snippets/announcement-bar.liquid og assets/lisen-annonce.css.

  HVORFOR IKKE TEMAETS EGEN SLIDER. Baren brugte slick. Den blev sat op, men
  kørte aldrig: på computer var den sat til at vise ALLE beskeder på én gang,
  så der var ikke noget at rotere, og på mobil stod de øvrige uden for
  skærmen. Målt 22. sep. 2026: teksten skiftede ikke i 12 sekunder. Snippet'en
  har derfor fået et andet id, så slick springer kassen over, og skiftet sker
  her i stedet – tredive linjer i stedet for et bibliotek.

  VAGTEN HEDDER IKKE LisenAnnonce, OG DET ER MED VILJE. Browseren laver selv
  en global variabel ud af hvert id i siden, og kassen hedder LisenAnnonce.
  Første version brugte window.LisenAnnonce som "har jeg kørt?"-markør – den
  var allerede sat, til selve elementet, så scriptet stoppede sig selv før
  det havde lavet noget. Symptomet var stumt: ingen fejl, baren stod bare
  stille. Døber man en af de to om, skal de stadig hedde noget forskelligt.

  DEN HOLDER PAUSE TRE STEDER:
    – når musen er over baren, eller noget i den har tastaturfokus, så man kan
      nå at læse færdigt og ramme linket
    – når fanen ligger i baggrunden, så den ikke tæller videre i det skjulte
      og springer flere beskeder over, når man kommer tilbage
    – ved "reducér bevægelse": så kører den slet ikke, og CSS'en stiller i
      stedet beskederne under hinanden, så alt kan læses

  TABINDEX PÅ LINKENE. En besked, der er tonet ud, er stadig i siden. Uden
  tabindex="-1" kunne man tabulere hen til et link, ingen kan se.
*/
(function () {
  'use strict';

  if (window.LisenAnnonceStyring) return;
  window.LisenAnnonceStyring = true;

  var stille = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function opsaet(kasse) {
    if (kasse.getAttribute('data-lisen-gjort')) return;
    kasse.setAttribute('data-lisen-gjort', 'ja');

    var beskeder = Array.prototype.slice.call(kasse.querySelectorAll('.lisen-annonce__besked'));
    if (beskeder.length < 2) return;

    var tid = (parseFloat(kasse.getAttribute('data-tid')) || 5) * 1000;
    var nu = 0;
    var pause = false;
    var ur = null;

    function vis(n) {
      beskeder.forEach(function (b, i) {
        var aktiv = i === n;
        b.classList.toggle('er-aktiv', aktiv);
        b.setAttribute('aria-hidden', aktiv ? 'false' : 'true');
        var link = b.querySelector('a');
        if (link) link.setAttribute('tabindex', aktiv ? '0' : '-1');
      });
      nu = n;
    }

    function skridt() {
      if (pause || document.hidden) return;
      vis((nu + 1) % beskeder.length);
    }

    vis(0);
    if (stille) return;

    ur = setInterval(skridt, tid);

    ['mouseenter', 'focusin'].forEach(function (navn) {
      kasse.addEventListener(navn, function () { pause = true; });
    });
    ['mouseleave', 'focusout'].forEach(function (navn) {
      kasse.addEventListener(navn, function () { pause = false; });
    });

    // Uret kører videre i en skjult fane, men skridt() springer over. Uden
    // det ville man komme tilbage til en bar, der lige havde skiftet fem
    // gange uden at nogen så det.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && ur) {
        clearInterval(ur);
        ur = setInterval(skridt, tid);
      }
    });
  }

  function start() {
    var kasser = document.querySelectorAll('[data-lisen-annonce]');
    for (var i = 0; i < kasser.length; i++) opsaet(kasser[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
